
import $ from "jquery"
import {EventEmitter} from "events"
import NumbersFormatter from "app/numbers/formatter/index"


export interface Selector {
  scope:  string | JQuery
  main:   string
  input:  string
}
export interface InputSelector {
  scope?:  string | JQuery
  main?:   string
  input?:  string
}
const DEFAULT_SELECTOR = {
  scope:  ".cell-real-estate-mortgages-calculator",
  main:   ".cell-real-estate-mortgages-calculator--listing-price",
  input:  ".cell-real-estate-mortgages-calculator_form-input",
}


export class InputSection extends EventEmitter {
  protected selector: Selector
  protected $scope: JQuery
  protected $el: JQuery
  protected $input: JQuery

  protected min_data: number
  protected max_data: number
  protected default_data: number

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)
    this.$el = this.$scope.find(this.selector.main)
    this.$input = this.$el.find(this.selector.input)

    this.min_data = this.$el.data("min")
    this.max_data = this.$el.data("max")
    this.default_data = this.$el.data("default")

    this.created()
    this.bind_action()
  }

  public val(){
    const input_val = this.$input.val()
    if (input_val == null) { return null }

    return NumbersFormatter.numberWithoutCommas(this.$input.val())
  }

  protected created(){
    return this
  }
  protected bind_action(){
    this.$input.on("change", () => {
      this.onInputChange()
    })
    return this
  }
  protected setInputVal(val: any){
    if (typeof val !== "string") { return }
    const value = NumbersFormatter.numberWithoutCommas(val)
    if (value == null) { return }

    if (!isFinite(value)){
      this.$input.val(this.default_data)
    }
    else if (value > this.max_data){
      this.$input.val(this.max_data)
    }
    else if (value <  this.min_data){
      this.$input.val(this.min_data)
    }

    if (this.$input.val() >= 1000){
      this.$input.val(NumbersFormatter.numberWithCommas(this.$input.val() || 0) || 0)
    }
  }
  protected onInputChange(){
    this.setInputVal(this.$input.val())
    this.emit("input_change")
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new InputSection(selector)
  },
}

export {
  Factory,
  DEFAULT_SELECTOR,
}
